<template>
  <div class="card mb-3">
    <div class="card-body">
      <form class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Chercher:</label>
            <input
              type="text"
              class="form-control"
              v-model="users.searchTerm"
              @change="filter()"
              placeholder="Chercher"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Par Date :</label>
            <!-- <rangedate-picker
              id="productid"
              ref="myInput"
              format="YYYY-MM-DD"
              i18n="EN"
              :presetRanges="presetRanges"
              :captions="captions"
            ></rangedate-picker> -->
          </div>
        </div>
        <div class="col-md-4 d-flex align-items-end">
          <button type="button" class="btn btn-primary mr-2" @click="fetchFilter()">
            Chercher
          </button>
          <button type="button" class="btn btn-danger" @click="Removefilter()">
            Annuler
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <h5 class="card-title mb-0">Historique des tâches</h5>
    </div>
    <div class="card-body" style="max-height: 100vh; overflow: auto">
      <template>
        <ul class="list ps-0 mb-0 list-unstyled">
          <li
            class="position-relative fw-medium text-dark-emphasis"
            v-for="item in History"
            :key="item.id"
          >
            <div
              class="icon position-absolute start-0 rounded-circle text-center"
            >
              <i class="ph-duotone ph-check-circle"></i>
            </div>
            <span class="text-black fw-bold">{{ item.task }}</span
            ><br />
            {{ item.task_code }}
            <span class="d-block fs-13 mt-1">{{
              getDate(item.created_at)
            }}</span>
          </li>
        </ul>

        <br />

        <div class="pagination">
          <button
            :disabled="filter.current_page === 1"
            @click="changePage(filter.current_page - 1)"
          >
            Prev
          </button>

          <!-- First page -->
          <button v-if="startPage > 1" @click="changePage(1)">1</button>
          <span v-if="startPage > 2">...</span>

          <!-- Middle pages -->
          <button
            v-for="page in pagesToShow"
            :key="page"
            :class="{ active: page === filter.current_page }"
            @click="changePage(page)"
          >
            {{ page }}
          </button>

          <!-- Last page -->
          <span v-if="endPage < totalPages">...</span>
          <button v-if="endPage < totalPages" @click="changePage(totalPages)">
            {{ totalPages }}
          </button>

          <button
            :disabled="filter.current_page === totalPages"
            @click="changePage(filter.current_page + 1)"
          >
            Next
          </button>
        </div>
        <!-- <nav aria-label="Page navigation" class="d-flex justify-content-center pb-2">
            <b-pagination
              v-model="users.current_page"
              hide-goto-end-buttons
              :total-rows="users.total"
              @input="GetData()"
            />
          </nav> -->
      </template>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import moment from "moment";
import { useRoute } from "vue-router";
import api from "@/utils/axios";
import { computed } from "vue";

export default {
  setup() {
    const route = useRoute();
    const loading = ref(false);
    const error = ref(false);
    const History = ref([]);
    const filter = reactive({
      searchTerm: "",
      searchType: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const colors = [
      "success",
      "info",
      "warning",
      "secondary",
      "danger",
      "primary",
    ];
    const filter_type = ref({ value: "", name: "Tous" });
    const myInput = ref(null);

    const presetRanges = {
      today: function () {
        const n = new Date();
        const today = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          label: "Aujoud'hui",
          active: false,
          dateRange: { start: today, end: today },
        };
      },
      Lastday: function () {
        const n = new Date();
        const today = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1)
        );
        return {
          label: "Hier",
          active: false,
          dateRange: { start: today, end: today },
        };
      },
      last7days: function () {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 6)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          label: "7 derniers jours",
          active: false,
          dateRange: { start, end },
        };
      },
      last30days: function () {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 30)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          label: "30 derniers jours",
          active: false,
          dateRange: { start, end },
        };
      },
      thisMonth: function () {
        const n = new Date();
        const start = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
        const end = new Date(Date.UTC(n.getFullYear(), n.getMonth() + 1, 0));
        return { label: "Ce mois", active: false, dateRange: { start, end } };
      },
      LastMonth: function () {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() - 1, 1)
        );
        const endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));
        return {
          label: "Le mois dernier",
          active: false,
          dateRange: { start: startMonth, end: endMonth },
        };
      },
      Lancement: function () {
        const n = new Date();
        const today = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          label: "Depuis Le Lancement",
          active: false,
          dateRange: { start: new Date("2019-12-20"), end: today },
        };
      },
    };

    const captions = {
      title: "Choisir une date",
      ok_button: "Appliquer",
    };

    const options = [
      { value: "", name: "Tous" },
      { value: "Colis", name: "Colis" },
      { value: "Bon Livraison", name: "Bons Livraison" },
      { value: "SentNote", name: "Bons Envois" },
      { value: "Invoice", name: "Fcatures" },
      { value: "Annonce", name: "Annonces" },
      { value: "Stock", name: "Stock" },
      { value: "Demandes Téléphone", name: "Demandes Téléphone" },
      { value: "Demandes RIB", name: "Demandes RIB" },
      { value: "Réclamations", name: "Réclamations" },
      { value: "Adresse", name: "Adresses" },
      { value: "Agence", name: "Agences" },
      { value: "Client", name: "Clients" },
      { value: "Caisse", name: "Caisses" },
      { value: "ClientRequest", name: "Demande Clients" },
      { value: "Coupon", name: "Coupons" },
      { value: "DeliveryInventory", name: "Bons de livraison (Stock)" },
      { value: "DistributionNote", name: "Bons des distribution" },
      { value: "LivreurRequest", name: "Demandes livreurs" },
      { value: "PaymentNote", name: "Bons de paiment (Client)" },
      { value: "PaymentZone", name: "Bons de paiment (Zone)" },
      { value: "PickupNote", name: "Demandes de ramassage" },
      { value: "ReturnNote", name: "Bons de retours" },
      { value: "ReceptionNote", name: "Bon de reception" },
      { value: "PointageNote", name: "Pointage" },
      { value: "Comptability", name: "Comptabilités" },
    ];

    // If you have a composable for $http, use it, otherwise use axios or fetch

    function GetData() {
      loading.value = true;
      api
        .get(
          `/api/auth/fectNoteHistories?searchTerm=${filter.searchTerm}&searchSDate=${filter.searchSDate}&searchEDate=${filter.searchEDate}&page=${filter.current_page}&per_page=${filter.per_page}`,
          {
            params: {
              rn: route.params.id,
              rn_ref: route.params.refNote,
              type: route.params.type,
            },
          }
        )
        .then((res) => {
          History.value = res.data.users.data;
          Object.assign(filter, res.data.users);
        })
        .catch(() => {
          error.value = true;
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const totalPages = computed(() =>
      Math.ceil(filter.total / filter.per_page)
    );

    const maxButtons = 5; // how many pages to show around current

    const startPage = computed(() =>
      Math.max(filter.current_page - Math.floor(maxButtons / 2), 1)
    );
    const endPage = computed(() =>
      Math.min(startPage.value + maxButtons - 1, totalPages.value)
    );

    const pagesToShow = computed(() => {
      const pages = [];
      for (let i = startPage.value; i <= endPage.value; i++) {
        pages.push(i);
      }
      return pages;
    });

    function getDate(value) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function GetColor() {
      return colors[Math.floor(Math.random() * colors.length)];
    }

    function fetchFilter() {
      filter.searchType = filter_type.value.value;
      // filter.searchSDate =
      //   myInput.value?.dateRange?.start === undefined
      //     ? ""
      //     : convert(myInput.value.dateRange.start);
      // filter.searchEDate =
      //   myInput.value?.dateRange?.end === undefined
      //     ? ""
      //     : convert(myInput.value.dateRange.end);
      GetData();
    }

    function Removefilter() {
      filter.searchType = "";
      filter.searchSDate = "";
      filter.searchEDate = "";
      filter.searchTerm = "";
      filter_type.value = { value: "", name: "Tous" };
      // if (myInput.value) myInput.value.dateRange = {};
      GetData();
    }

    function convert(date) {
      return moment(date).format("YYYY-MM-DD");
    }

    const changePage = (page) => {
      if (page < 1 || page > totalPages.value) return;
      filter.current_page = page;
      GetData();
    };

    onMounted(() => {
      GetData();
    });

    return {
      loading,
      error,
      History,
      filter,
      colors,
      filter_type,
      presetRanges,
      captions,
      options,
      myInput,
      GetData,
      getDate,
      GetColor,
      Removefilter,
      convert,
      pagesToShow,
      totalPages,
      changePage,
      fetchFilter
    };
  },
};
</script>

